import { BaseControlDef, BaseElementDefBase, BaseElementDef } from "./BaseElementDef";
import { FormMultiControlItem } from "@cs/FormMultiControlItem";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { CheckGroupSettings } from "@cs-ts/check-group-settings";
import { CheckItemSettings } from "@cs-ts/check-item-settings";
import { CheckGroupItem } from "@cs-ts/check-group-item";
import { CalculationContext } from "./__CalculationContextInterface";
import { map } from "rxjs/operators";
import { combineLatest, from, Observable } from "rxjs";
import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { stringCoalesce } from "@/lib/whitespaceMethods";

export default class CheckGroupDef extends BaseControlDef<CheckGroupSettings, FormDefinitionItem<CheckGroupSettings>, FormMultiControlItem, string[]> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormMultiControlItem, definitionData: FormDefinitionItem<CheckGroupSettings>, calculationContext: CalculationContext) {
        // value needs to be a list for Vue template to function
        if (elementData != null && elementData.value == null) {
            elementData.value = [];
        }
        super(parentElement, elementData, definitionData, calculationContext);
        this._hasValue = elementData == null || elementData.value == null || elementData.value.length == 0 ? this.getValueFromDependencies()!.length > 0 : elementData.hasValue;
        this.typeName = "MI.Common.DynamicForms.Models.DFCheckGroup"; // TODO - not hardcoded?
        this.isFocusable = true;
    }

    getValueFromDependencies() {
        let result = super.getValueFromDependencies();
        // value needs to be a list for Vue template to function
        if (result == null) {
            result = [];
        }
        return result;
    }

    defaultValue$() {
        return combineLatest([super.defaultValue$(), this.effectiveItems$()]).pipe(
            map(([dV, eI]) => {
                //@ts-ignore
                return dV.filter(d => eI.some(e => e.value == d));
            }),
        );
    }

    /** @returns {Observable<{value: string, label: string}[]>} */
    effectiveItems$(): Observable<{ value: string; label: string }[]> {
        const layout = this.definition.settings.layout;
        if (layout == 3) {
            const items = this.children as BaseElementDef<CheckItemSettings, FormDefinitionItem<CheckItemSettings>, FormItem>[];
            const buildItems = [];
            for (let index = 0; index < items.length; index++) {
                const item = items[index];
                const label = item.definition.settings.label!;
                const value = item.definition.settings.value;
                buildItems.push({ label, value: stringCoalesce(value, label)! });
            }
            return from([buildItems]);
        } else {
            const item$s = [] as Observable<{ value: string; label: string }[]>[];
            const items = this.definition.settings.items;
            for (let index = 0; index < items.length; index++) {
                const item = items[index];
                let label$ = null;
                if ("labelCalculationId" in item && item.labelCalculationId) {
                    //@ts-ignore
                    label$ = this.resolveCalculation(item.labelCalculationId);
                } else {
                    label$ = from([[(<CheckGroupItem>item).label]]);
                }
                let value$ = null;
                if ("valueCalculationId" in item && item.valueCalculationId) {
                    //@ts-ignore
                    value$ = this.resolveCalculation(item.valueCalculationId);
                } else {
                    value$ = from([[(<CheckGroupItem>item).value]]);
                }
                //@ts-ignore
                item$s.push(combineLatest([label$, value$]).pipe(map(([label, value]) => (label.length >= value.length ? label.map((i, j) => ({ label: i, value: value[j] })) : value.map((i, j) => ({ value: i, label: label[j] }))).map(({ label, value }) => ({ label, value: value == null || /^\s*$/.test(value) ? label : value })))));
            }
            return combineLatest(item$s).pipe(map(i => i.flat()));
        }
    }
    //@ts-ignore
    _validateChild$(child) {
        return combineLatest([super._validateChild$(child), this.value$().pipe(map((values: string[]) => values != null && values.indexOf(child.definition.settings.effectiveValue) >= 0))]).pipe(map(([a, b]) => a && b));
    }
}
